import React from 'react';
   
const Home = () => {
    return (
        <h2 className="App">Home</h2>
    )
};

export default Home;